import { useId } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: 11,
  },
  label: {
    marginBottom: 5,
    fontSize: 11,
    fontWeight: 600,
    color: "var(--adm-text-muted)",
  },
  customSelect: {
    backgroundColor: "var(--adm-surface)",
    color: "var(--adm-text)",
    fontSize: 12,
    height: 38,
    borderRadius: 9,

    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--adm-border)",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#dcdfe6",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--adm-dark)",
      borderWidth: 1,
    },
  },
  // Нэг мөрийн хувилбар: шошго нь дээрээ биш, хүрээн дотроо хөвнө
  // (огнооны талбартай ижил харагдана).
  inlineRoot: {
    width: "100%",
    "& .MuiInputLabel-root": {
      fontSize: 12,
      color: "var(--adm-text-muted)",
      transform: "translate(12px, 11px) scale(1)",
    },
    "& .MuiInputLabel-shrink": {
      transform: "translate(13px, -6px) scale(0.85)",
    },
  },
}));

const CustomComboBox = ({
  label,
  onChange,
  items,
  value,
  prefix = "",
  prefixIndex = 0,
  inline = false,
}) => {
  const classes = useStyles();
  const labelId = useId();

  const handleChange = (e) => {
    // onChange(e.target.value);
    const selectedOption = items.find((item) => item.value === e.target.value);
    onChange(e.target.value, selectedOption.id);
  };

  const options = items.map((item, ind) => (
    <MenuItem key={ind} value={item.value}>
      {item.name + (prefixIndex <= ind ? prefix : "")}
    </MenuItem>
  ));

  if (inline) {
    return (
      <FormControl className={classes.inlineRoot}>
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
          labelId={labelId}
          label={label}
          value={value}
          onChange={handleChange}
          variant={"outlined"}
          className={classes.customSelect}
        >
          {options}
        </Select>
      </FormControl>
    );
  }

  return (
    <Box className={classes.root}>
      <Typography variant={"h6"} className={classes.label}>
        {label}
      </Typography>
      <Select
        value={value}
        onChange={handleChange}
        variant={"outlined"}
        className={classes.customSelect}
      >
        {options}
      </Select>
    </Box>
  );
};

export default CustomComboBox;
